module.exports = __webpack_public_path__ + "img/camera.12c9d739.png";